import React from 'react';
import qwickIconSvg from '../assets/qwick-icon.svg';

export interface LetterheadConfig {
  enabled: boolean;
  companyName: string;
  logoText?: string;
  tagline?: string; // Tagline shown below logo
  address: string;
  email: string;
  phone: string;
  website: string;
  // Logo styling
  logoSize: 'tiny' | 'small' | 'medium' | 'large' | 'extra-large';
  logoVariant: 'default' | 'high-contrast' | 'monochrome' | 'on-primary';
  logoUrl?: string; // Custom logo URL or data URL for uploaded image
  headerAlign?: 'left' | 'center' | 'right'; // Header alignment
  // Template support
  headerTemplate?: string; // Mustache template for custom header
  footerTemplate?: string; // Mustache template for custom footer
}

export const DEFAULT_LETTERHEAD: LetterheadConfig = {
  enabled: true,
  companyName: 'QwickPDF',
  logoText: 'wick PDF',
  tagline: 'Professional PDFs from Markdown',
  address: '',
  email: 'contact@qwickapps.com',
  phone: '+1 (978) 566-9223',
  website: 'https://qwickapps.com',
  logoSize: 'small',
  logoVariant: 'default',
  headerAlign: 'left',
};

// Helper function to create default icon element (not stored in config to avoid serialization issues)
export const createDefaultIcon = () =>
  React.createElement('img', {
    src: qwickIconSvg,
    alt: 'QwickApps',
    style: {
      display: 'block',
      height: '32px',
      width: '32px',
    },
  });
